import { describeMutationError } from "@api/mutationErrors";
import { useWriteErrorStore } from "@api/writeErrorStore";
import { ClinicAuthError } from "@auth/clinicAuthClient";
import { MutationCache, QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  // Mutations reject after render, so no error boundary sees them. On the cache, not
  // `defaultOptions.mutations`, because a per-mutation `onError` would replace that default.
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.handled) return;
      useWriteErrorStore
        .getState()
        .show(describeMutationError(error, mutation.meta?.action));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (
          error instanceof ClinicAuthError &&
          error.code === "invalid_credentials"
        )
          return false;
        return failureCount < 2;
      },
    },
  },
});
